import { Extension, Mark } from "@tiptap/core";
import StarterKit from "@tiptap/starter-kit";
import { TableKit } from "@tiptap/extension-table";
import Subscript from "@tiptap/extension-subscript";
import Superscript from "@tiptap/extension-superscript";
import Placeholder from "@tiptap/extension-placeholder";
import { isSafeContractHref } from "../patients/contract-html";

const legacyAttributes = {
  align: {
    default: null,
    parseHTML: (element: HTMLElement) => element.getAttribute("align"),
    renderHTML: (attributes: Record<string, unknown>) => typeof attributes.align === "string" ? { align: attributes.align } : {},
  },
  class: {
    default: null,
    parseHTML: (element: HTMLElement) => element.getAttribute("class"),
    renderHTML: (attributes: Record<string, unknown>) => typeof attributes.class === "string" ? { class: attributes.class } : {},
  },
  dir: {
    default: null,
    parseHTML: (element: HTMLElement) => element.getAttribute("dir"),
    renderHTML: (attributes: Record<string, unknown>) => typeof attributes.dir === "string" ? { dir: attributes.dir } : {},
  },
};

const LegacyBlocks = Extension.create({
  name: "contractLegacyBlocks",
  addGlobalAttributes() {
    return [{
      types: ["paragraph", "heading", "listItem", "orderedList", "bulletList", "blockquote", "table", "tableRow", "tableCell", "tableHeader"],
      attributes: legacyAttributes,
    }, {
      types: ["orderedList"],
      attributes: {
        type: {
          default: null,
          parseHTML: (element: HTMLElement) => element.getAttribute("type"),
          renderHTML: (attributes: Record<string, unknown>) => typeof attributes.type === "string" && ["1", "A", "a", "I", "i"].includes(attributes.type) ? { type: attributes.type } : {},
        },
      },
    }];
  },
});

const LegacySpan = Mark.create({
  name: "contractLegacySpan",
  addAttributes: () => legacyAttributes,
  parseHTML: () => [{ tag: "span[class]" }, { tag: "span[dir]" }],
  renderHTML: ({ HTMLAttributes }) => ["span", HTMLAttributes, 0],
});

export const contractEditorExtensions = [
  StarterKit.configure({
    trailingNode: false,
    link: {
      openOnClick: false,
      autolink: false,
      linkOnPaste: false,
      isAllowedUri: (url: string) => isSafeContractHref(url),
      HTMLAttributes: { rel: "noopener noreferrer", target: "_blank" },
    },
  }),
  TableKit.configure({ table: { resizable: false } }),
  Placeholder.configure({ placeholder: "Escreva o contrato e personalize com campos automáticos…" }),
  Subscript,
  Superscript,
  LegacyBlocks,
  LegacySpan,
];
